<template lang="pug">
  div#app
    router-view
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
@import '~styles/reset.css';
@import '~styles/content.css';

@font-face {
  font-family: 'BritannicBold';
  src: url("~@/assets/fonts/BritannicBold/BritannicBold.eot");
  src: url("~@/assets/fonts/BritannicBold/BritannicBold.eot?#iefix") format('embedded-opentype'),
       url("~@/assets/fonts/BritannicBold/BritannicBold.woff") format('woff'),
       url("~@/assets/fonts/BritannicBold/BritannicBold.ttf") format('truetype');
  font-weight: bold;
  font-style: bold;
}
@font-face {
  font-family: 'ChineseTakeaway';
  src: url("~@/assets/fonts/ChineseTakeaway/ChineseTakeaway.eot");
  src: url("~@/assets/fonts/ChineseTakeaway/ChineseTakeaway.eot?#iefix") format('embedded-opentype'),
       url("~@/assets/fonts/ChineseTakeaway/ChineseTakeaway.woff") format('woff'),
       url("~@/assets/fonts/ChineseTakeaway/ChineseTakeaway.ttf") format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'MarketDeco';
  src: url("~@/assets/fonts/MarketDeco/MarketDeco.eot");
  src: url("~@/assets/fonts/MarketDeco/MarketDeco.eot?#iefix") format('embedded-opentype'),
       url("~@/assets/fonts/MarketDeco/MarketDeco.woff") format('woff'),
       url("~@/assets/fonts/MarketDeco/MarketDeco.ttf") format('truetype');
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// App.vue?1c49eb3c